import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { v4 as uuidv4 } from 'uuid';
export default {
  props: {
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      optionsDropState: false
    };
  },
  computed: {
    // 是否可拖拽删除
    isViewDelOrDrop: function isViewDelOrDrop(vm) {
      return vm.form.options && vm.form.options.length > 1;
    }
  },
  methods: {
    handleMouse: function handleMouse(state) {
      var _this = this;
      this.$nextTick(function () {
        _this.optionsDropState = state;
      });
    },
    // 添加选项
    handleAdd: function handleAdd() {
      this.form.options.push({
        id: uuidv4(),
        label: ''
      });
    },
    // @parma { number } index 下标
    handleDel: function handleDel(index) {
      this.form.options.splice(index, 1);
    },
    // 组件内拖拽开始
    handleDragStart: function handleDragStart(event, index) {
      event.dataTransfer.setData('index', index);
    },
    // 拖拽结束放置
    handleItemDrop: function handleItemDrop(event, index) {
      event.stopPropagation();
      var options = this.form.options;
      // 首先获取将要换位的组件
      var paramIndex = +event.dataTransfer.getData('index');
      var target = options.splice(paramIndex, 1)[0];
      // 然后拿到之后插入到目标位置
      options.splice(index, 0, target);
    }
  }
};